// extracted by mini-css-extract-plugin
export var buttonArea = "form-module--buttonArea--mcku+";
export var consentArea = "form-module--consentArea--cg-Eo";
export var consentStatement = "form-module--consentStatement--uaLiH";
export var error = "form-module--error--qVaAO";
export var errorMessage = "form-module--errorMessage--RcVAk";
export var form = "form-module--form--kRRqr";
export var nullValue = "form-module--nullValue--F3Pgd";
export var selectLabel = "form-module--selectLabel--zmgs7";
export var textArea = "form-module--textArea--6G9qx";